import { render, staticRenderFns } from "./DccExpiredModal.vue?vue&type=template&id=467e9704&scoped=true"
import script from "./DccExpiredModal.vue?vue&type=script&lang=js"
export * from "./DccExpiredModal.vue?vue&type=script&lang=js"
import style0 from "./DccExpiredModal.vue?vue&type=style&index=0&id=467e9704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e9704",
  null
  
)

export default component.exports